import type { ReactNode } from 'react';
import { DEVICE_FRAME_RETENTION_DAYS } from '@/session/db.js';

/**
 * What turning on "Help improve detection" does, in one place for the sign-up
 * question, the opt-in screen and the pointer beside replays. Facts only, the
 * purpose first (LEGAL §3): the session-keeping benefit is a consequence of the
 * files living in the account, not a reward attached to consent. The choice
 * itself is two equal buttons (at sign-up "Yes" starts selected — see
 * ConsentPage and LEGAL §3).
 */
export function SharingBenefits({ className = '' }: { className?: string }): ReactNode {
  const days = DEVICE_FRAME_RETENTION_DAYS;
  return (
    <ul className={`list-disc space-y-1 pl-5 text-sm text-ink-soft ${className}`}>
      <li>
        <span className="font-semibold text-ink">Better detection.</span> It teaches the app to tell
        reaching for a cup from a real slouch.
      </li>
      <li>
        <span className="font-semibold text-ink">A better Erectus.</span> Your sessions help us improve
        the app for everyone who uses it.
      </li>
      <li>
        <span className="font-semibold text-ink">Your sessions, kept.</span> This phone keeps replays
        for {days} days. Shared sessions stay in your account, so you can replay them any time, on any
        device — including the last {days} days still on this phone when you turn sharing on.
      </li>
    </ul>
  );
}

/** The terms that go with it, said next to the benefits every time. */
export function SharingTerms(): ReactNode {
  return (
    <p className="text-xs text-muted">
      Never shared: video or pictures — they never leave your phone. Turn sharing off any time in
      Settings: what you shared is deleted, and replays go back to {DEVICE_FRAME_RETENTION_DAYS} days
      on this phone.
    </p>
  );
}
